import React from "react";
import { ActivityIndicator, StyleSheet, Text, View } from "react-native";

const AppLoadingScreen: React.FC = () => (
  <View style={styles.container}>
    <ActivityIndicator size="large" color="#9ca3af" style={styles.spinner} />
    <Text style={styles.text}>Loading...</Text>
  </View>
);

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "white",
  },
  spinner: {
    marginBottom: 16,
  },
  text: {
    color: "#6b7280",
    fontSize: 16,
  },
});

export default AppLoadingScreen;
